import { render } from "./Country.vue?vue&type=template&id=52a579cd&ts=true"
import script from "./Country.ts?vue&type=script&lang=ts"
export * from "./Country.ts?vue&type=script&lang=ts"

import "./Country.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/codebuild/output/src986595998/src/codestar-connections.eu-central-1.amazonaws.com/git-http/637423171848/eu-central-1/0deacb55-d326-4e40-91f1-5700b2b633c7/studyportals/Visa-Display/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__